module.exports = __webpack_public_path__ + "static/media/hr.ab48a7b8.svg";